<template>
  <base-material-card
    color="primary"
    icon="mdi-file-search-outline"
    inline
    class="px-5 py-5"
  >
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        Nova Consulta de Log de Unitização
      </div>
    </template>

    <v-form class="pt-5">
      <v-row class="mx-4">
        <v-col cols="12">
          <v-alert
            dense
            outlined
            type="info"
          >
            A consulta será processada em segundo plano e o arquivo ficará disponível para download na aba <strong>Consultas</strong> do histórico.
          </v-alert>
        </v-col>
      </v-row>

      <v-row
        align="center"
        no-gutters
        class="mx-4"
      >
        <v-col cols="12">
          <v-textarea
            id="codigos-obra-log-unitizacao-consulta"
            v-model="codigosObra"
            label="Códigos de Obra*"
            outlined
            hint="Digite um código por linha"
            persistent-hint
            rows="6"
            :error-messages="codigosError"
          />
        </v-col>
      </v-row>

      <v-row
        v-if="pepsParaImobilizado.length"
        class="mx-4 mt-2"
      >
        <v-col
          v-for="pep in pepsParaImobilizado"
          :key="pep"
          cols="12"
          md="6"
          class="py-0"
        >
          <v-row
            align="center"
            dense
          >
            <v-col
              cols="12"
              md="5"
            >
              <v-text-field
                :value="pep"
                label="PEP"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="7"
            >
              <v-textarea
                v-model="imobilizadosPorPep[pep]"
                label="Imobilizados"
                outlined
                dense
                rows="3"
                auto-grow
                hint="Informe um por linha ou separe por vírgula/ponto e vírgula."
                persistent-hint
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
export default {
  name: 'LogUnitizacaoParametrosConsulta',

  data() {
    return {
      codigosObra: '',
      imobilizadosPorPep: {},
      codigosError: []
    };
  },

  watch: {
    codigosObra() {
      this.sincronizarImobilizadosPorPep();
      this.validateCodigos();
      this.notifyValidationChange();
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.sincronizarImobilizadosPorPep();
      this.notifyValidationChange();
    });
  },

  computed: {
    pepsParaImobilizado() {
      return this.normalizarCodigosObra()
        .filter((codigo, index, codigos) => codigos.indexOf(codigo) === index)
        .slice(0, 20);
    }
  },

  methods: {
    normalizarCodigosObra() {
      return this.codigosObra
        .split(/\r?\n/g)
        .map((codigo) => codigo.trim())
        .filter((codigo) => codigo.length > 0);
    },

    exportData() {
      if (!this.validate()) {
        throw new Error(this.codigosError[0] || 'É necessário informar ao menos um código de obra.');
      }

      return {
        codigos_obra: this.normalizarCodigosObra(),
        imobilizados_por_pep: this.getImobilizadosPorPepPreenchidos()
      };
    },

    getImobilizadosPorPepPreenchidos() {
      return this.pepsParaImobilizado
        .map((pep) => {
          return {
            pep,
            imobilizados: this.normalizarImobilizados(this.imobilizadosPorPep[pep] || '')
          };
        })
        .filter((item) => item.imobilizados.length > 0);
    },

    normalizarImobilizados(valor) {
      return valor
        .split(/[,\s;]+/g)
        .map((imobilizado) => imobilizado.trim())
        .filter((imobilizado, index, imobilizados) => imobilizado.length > 0 && imobilizados.indexOf(imobilizado) === index);
    },

    sincronizarImobilizadosPorPep() {
      const valoresAtuais = this.imobilizadosPorPep;
      const proximosValores = {};

      this.pepsParaImobilizado.forEach((pep) => {
        proximosValores[pep] = valoresAtuais[pep] || '';
      });

      this.imobilizadosPorPep = proximosValores;
    },

    validateCodigos() {
      const isValid = this.normalizarCodigosObra().length > 0;
      this.codigosError = isValid ? [] : ['É necessário informar ao menos um código de obra.'];
      return isValid;
    },

    validate() {
      return this.validateCodigos();
    },

    notifyValidationChange() {
      this.$nextTick(() => {
        this.$emit('validation-change', this.validate());
      });
    }
  }
};
</script>
